'use strict';

angular.module('portal.login')
    .controller('Unsubscribe', ['$scope', '$stateParams', 'Users', function ($scope, $stateParams, Users) {

        $scope.userID = $stateParams.userID;
        $scope.promises = [];

        $scope.promises.push(Users.unsubscribe({ userID: $scope.userID }).then(function (result) {
            $scope.unsubscribeSucceeded = result;
        }).catch(function (error) {
            $scope.unsubscribeSucceeded = false;
        }));
    }]);
